import dayjs from 'dayjs'
import { Message, ScheduledMessage } from 'src/models/Message'
import { IterableElement } from 'type-fest'
import {
  MessageGuest,
  Messages,
  PostGroupMessageParam,
  PostScheduledMessageParam,
  PutMessageParam,
  ScheduledSendingMessages,
} from '../types/message'

export const toMessage = (
  message: IterableElement<Messages['messages'] | MessageGuest['messages']>,
): Message => ({
  id: message.id,
  uniqueId: message.uniqueId,
  content: {
    text: message.content,
    imageSources: message.companyDocuments.filter(
      (doc) => !doc.filename.endsWith('.pdf'),
    ),
    documents: message.companyDocuments.filter((doc) =>
      doc.filename.endsWith('.pdf'),
    ),
  },
  sentAt: dayjs(message.sendAt),
  senderId: message.sender.id,
  readCount:
    'numberOfReaded' in message
      ? message.numberOfReaded
      : 'readFlag' in message && message.readFlag
      ? 1
      : 0,
  readCompanyNames:
    'readedCompanyNames' in message ? message.readedCompanyNames : undefined,
  destroyUrl: message.destroyUrl,
  deleted: message.deleted,
  reported: 'reportedMessage' in message ? message.reportedMessage : false,
})

export const toScheduledMessage = (
  message: IterableElement<
    ScheduledSendingMessages['scheduledSendingMessages']
  >,
): ScheduledMessage => ({
  id: message.id,
  content: {
    text: message.content,
    imageSources: message.scheduledSendingDocuments?.filter(
      (doc) => !doc.filename.endsWith('.pdf'),
    ),
    documents: message.scheduledSendingDocuments?.filter((doc) =>
      doc.filename.endsWith('.pdf'),
    ),
  },
  scheduledAt: dayjs(message.scheduledSendingAt),
  senderId: message.sender ? message.sender.id : message.senderId!!,
  destroyUrl: message.destroyUrl,
  updateUrl: message.updateUrl,
})

export const roomFormData = (param: PutMessageParam) => {
  const formData = new FormData()
  formData.append('company_message[id]', param.id.toString())
  if (param.content) formData.append('company_message[content]', param.content)
  if (param.isGreet != null) formData.append('is_greet', String(param.isGreet))
  if (param.noAttention != null)
    formData.append('no_attention', String(param.noAttention))
  param.ccEmail?.forEach((email) => {
    formData.append('company_message[ccEmail][]', email)
  })
  param.companyDocuments?.forEach((doc) => {
    formData.append('company_message[company_documents][][file]', doc)
  })
  return formData
}

export const groupRoomFormData = (param: PostGroupMessageParam) => {
  const formData = new FormData()
  formData.append('room_id', param.id.toString())
  if (param.content) formData.append('content', param.content)
  if (param.noAttention != null)
    formData.append('no_attention', String(param.noAttention))
  param.companyDocuments?.forEach((doc) => {
    formData.append('company_document_groups[][file]', doc)
  })
  return formData
}

export const scheduledMessageFormData = (param: PostScheduledMessageParam) => {
  const formData = new FormData()
  formData.append('scheduled_sending_message[room_type]', param.roomType)
  formData.append('scheduled_sending_message[room_id]', param.id.toString())
  if (param.content)
    formData.append('scheduled_sending_message[content]', param.content)

  formData.append(
    'scheduled_sending_message[scheduled_sending_at]',
    param.scheduledAt.toString(),
  )
  if ('ccEmail' in param)
    param.ccEmail?.forEach((email) => {
      formData.append('scheduled_sending_message[additional_data][]', email)
    })
  param.companyDocuments?.forEach((doc) => {
    formData.append(
      'scheduled_sending_message[scheduled_sending_documents][][file]',
      doc,
    )
  })
  if (param.isGreet != null) formData.append('is_greet', String(param.isGreet))
  return formData
}
